import { useEffect, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { websiteBaseUrl } from "../apis/apis";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const CompletionModal = ({ open }) => {
  const [showManualCloseMessage, setShowManualCloseMessage] = useState(false);

  useEffect(() => {
    if (open) {
      setShowManualCloseMessage(false);
    }
  }, [open]);

  if (!open) return null;

  const handleCloseTab = () => {
    // Some browsers block window.close() for tabs not opened via script.
    // Try close first, then show a manual-close message if blocked.
    setShowManualCloseMessage(false);
    window.open("", "_self");
    window.close();
    setTimeout(() => {
      if (!window.closed) {
        setShowManualCloseMessage(true);
      }
    }, 100);
  };

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 20000, // Ensure modal appears above text fields (10000+) and other modals
      }}
    >
      <Box
        sx={{
          backgroundColor: "white",
          padding: 4,
          borderRadius: 2,
          maxWidth: 400,
          textAlign: "center",
        }}
      >
        <CheckCircleIcon
          sx={{
            fontSize: 60,
            color: "#28c76f",
            mb: 2,
          }}
        />
        <Typography variant="h5" sx={{ mb: 2 }}>
          Document Completed
        </Typography>
        <Typography variant="body1" sx={{ mb: 3, color: "text.secondary" }}>
          Learn more about RequireSign by visiting our website.
        </Typography>

        <Box sx={{ display: "flex", gap: 1.5, justifyContent: "center", flexWrap: "wrap" }}>
          <Button
            variant="contained"
            onClick={() => window.open(websiteBaseUrl)}
            sx={{
              bgcolor: "#28c76f",
              boxShadow: "none",
              "&:hover": { bgcolor: "#1f9d57", boxShadow: "none" },
            }}
          >
            Go to Website
          </Button>
          <Button
            variant="contained"
            onClick={handleCloseTab}
            sx={{
              bgcolor: "#d32f2f",
              boxShadow: "none",
              "&:hover": { bgcolor: "#b71c1c", boxShadow: "none" },
            }}
          >
            Close
          </Button>
        </Box>
        {showManualCloseMessage ? (
          <Typography
            variant="caption"
            sx={{ mt: 1.5, display: "block", color: "#d32f2f", fontWeight: 500 }}
          >
            Please close this tab manually.
          </Typography>
        ) : null}
      </Box>
    </Box>
  );
};
export default CompletionModal;
